<mat-form-field *ngIf="newSubOrg" class="copo-users-search-filter quick-search" appearance="outline" subscriptSizing="dynamic">
		<input [placeholder]="'add-suborg.quick-search' | translate" matInput type="text" spellcheck="false"
			autocomplete="off" [formControl]="searchTextControl" />
		<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');"
			tabindex="-1" matSuffix>
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
		<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
	</mat-form-field>
	<mat-error *ngIf="nextClicked && !isAnyOneUserSelected && newSubOrg" translate>add-suborg.please-select</mat-error>
	<ag-grid-angular [ngClass]="newSubOrg? 'ag-theme-balham users-list' : 'ag-theme-balham admin-list'"
		*ngIf="!isLoading  else loading" [gridOptions]="gridOptions" [modules]="modules"
		[rowData]="newSubOrg?userList:orgUserList" (gridReady)="onGridReady($event)"></ag-grid-angular>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>